
import {
  getStaSizeConfig,
  getStaSizeStatistics
} from "@/api/oms-operation-service";
import { Component, Vue } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import updataSiteSize from "./components/updata-site-size/updata-site-size.vue";
import { State } from "vuex-class";
import i18n from "@/config/i18n";
import statisticsItem from "@/components/statistics-item/statistics-item.vue";
import statisticsBox from "@/components/statistics-box/statistics-box.vue";
@Component({
  components: {
    "pi-updata-site-size": updataSiteSize,
    "pi-statistics-item": statisticsItem,
    "pi-statistics-box": statisticsBox
  }
})
export default class SystemConfigUser extends Vue {
  @State("sys") sys!: objAny;
  private privilege: objAny = {};
  private loading = false;
  private formInline: objAny = {};
  private staSizeData: objAny = {};
  private staSize: objAny = {};
  private statisticsList: objAny[] = [
    {
      name: i18n.t("siteSizeConfig.smallSizeStaNum"), // "小规模"
      key: "smallSizeStaNum",
      baColor: "bg-blue"
    },
    {
      name: i18n.t("siteSizeConfig.mediumSizeStaNum"), //"中规模",
      key: "mediumSizeStaNum",
      baColor: "bg-blue"
    },
    {
      name: i18n.t("siteSizeConfig.largeSizeStatNum"), //"大规模",
      key: "largeSizeStatNum",
      baColor: "bg-blue"
    }
  ];
  private tableList: object[] = [];
  private tableColumns: object[] = [
    {
      title: i18n.t("siteSizeConfig.configName"), //"配置名称",
      key: "configName",
      minWidth: 110
    },
    {
      title: i18n.t("siteSizeConfig.pileNum"), //"桩数量（个）",
      key: "pileNum",
      minWidth: 130
    },
    {
      title: i18n.t("siteSizeConfig.power"), //"功率（kw）",
      key: "power",
      minWidth: 130
    }
  ];

  public updataItem(): void {
    const updataSiteSize: objAny = this.$refs.updataSiteSize || {};
    updataSiteSize.open(this.staSize);
  }
  async getMapStaSize(): Promise<void> {
    const ret = await getStaSizeStatistics(this.formInline);
    if (ret.status == this["$config"].apiStatus) {
      const data = ret.data[0] || {};
      this.staSizeData = data;
    }
  }
  async getTableList(): Promise<void> {
    this.loading = true;
    const ret = await getStaSizeConfig(this.formInline);
    if (ret.status === this.$config.apiStatus) {
      const data: objAny = ret.data[0] || {};
      this.staSize = data;
      this.tableData(data);
    }
    this.loading = false;
  }
  public tableData(data: objAny): void {
    const tableList = [
      {
        configName: i18n.t("siteSizeConfig.smallSizeStaNum"), //"小规模",
        pileNum: "<" + data.pileMinValue,
        power: "<" + data.powerMinValue
      },
      {
        configName: i18n.t("siteSizeConfig.mediumSizeStaNum"), //"中规模",
        pileNum: data.pileMinValue + "~" + data.pileMaxValue,
        power: data.powerMinValue + "~" + data.powerMaxValue
      },
      {
        configName: i18n.t("siteSizeConfig.largeSizeStatNum"), //"大规模",
        pileNum: ">" + data.pileMaxValue,
        power: ">" + data.powerMinValue
      }
    ];
    this.tableList = tableList;
  }

  mounted() {
    this.privilege = this.$route.meta.privilegeVoObj;
    this.getTableList();
    this.getMapStaSize();
  }
}
